import type { Employee } from '../types/employee';

export type LaborRiskType = 'minWage' | 'fourInsurance' | 'holidayAllowance';
export interface LaborRisk {
  employeeName: string;
  type: LaborRiskType;
  message: string;
  severity: 'high' | 'mid';
}
export interface LaborRiskRates {
  minWageHourly: number;
  weeklyRestMinHours: number;
}

const won = (n: number): string => `${Math.round(n).toLocaleString('ko-KR')}`;

/** 시급제 판별: payType 우선, 없으면 legacy isHourly. */
const isHourlyPay = (e: Employee): boolean =>
  e.payType === 'hourly' || (e.payType == null && e.isHourly);

/** 직원별 노무 리스크 탐지. 요율은 인자로 주입(순수). 퇴직자 제외. */
export function detectLaborRisks(employees: Employee[], rates: LaborRiskRates): LaborRisk[] {
  const risks: LaborRisk[] = [];
  for (const e of employees) {
    if (e.isRetired) continue;
    const hourly = isHourlyPay(e);

    if (hourly && e.hourlyRate > 0 && e.hourlyRate < rates.minWageHourly) {
      risks.push({
        employeeName: e.name,
        type: 'minWage',
        severity: 'high',
        message: `${e.name}님 시급이 최저임금(${won(rates.minWageHourly)})보다 낮아요`,
      });
    }

    // 4대보험 가입 기준 주 15시간(근로기준법) — 주휴 기준 rates.weeklyRestMinHours 와 별개의 법정 임계이므로 리터럴 유지
    if (e.weeklyWorkHours >= 15 && !e.hasFourInsurance) {
      risks.push({
        employeeName: e.name,
        type: 'fourInsurance',
        severity: 'high',
        message: `${e.name}님 4대보험 가입 대상이에요`,
      });
    }

    if (hourly && e.weeklyWorkHours >= rates.weeklyRestMinHours && !e.isweeklyWork) {
      risks.push({
        employeeName: e.name,
        type: 'holidayAllowance',
        severity: 'mid',
        message: `${e.name}님 주휴수당 발생 대상이에요`,
      });
    }
  }
  return risks;
}
